export abstract class DataTransformPlugin {
  abstract transformData(series: { data: { x: number; y: number }[] }[]): Promise<unknown>
}

export default DataTransformPlugin
